// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtDate } from '../../../../trix-web-data-commons';

//
// Type
//
import {
    type CellRendererFactoryProps,
    type CellProps,
} from '../types/CellProps';

//
// Helper
//
import { renderAsLink } from './tools';

//
// Component
//
const createDateCellRenderer = (cfg: CellRendererFactoryProps): any => (props: CellProps): any => {
    return (
        <div>
            {renderAsLink(cfg.onClick, props.row)(fmtDate(props.value, 'LL'))}
        </div>
    );
};
export default createDateCellRenderer;
